import { isIncompletePhoneNumber, isPhoneFieldKey } from '../utils/phone';

export const capitalizeFirstLetter = (str: string | null | undefined): string => {
    if (str == null) { return ''; }
    return str
        .split(' ')
        .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
        .join(' ');
};

export const trimFloat = (float: number): number => {
    return parseFloat(float.toFixed(2));
};

export function truncateString(string: string, maxLength: number): string {
    if (string.length <= maxLength) {
        return string;
    }

    return string.slice(0, maxLength) + '...';
}

export function camelToSnake(camelCaseString: string): string {
    return camelCaseString.replace(/[A-Z]/g, (match) => `_${match.toLowerCase()}`);
}

/**
 * Recursively convert empty/whitespace-only strings to undefined so they are
 * dropped by JSON.stringify (backend receives null / missing key).
 * Incomplete phone values (country code only, e.g. +234) are also dropped.
 */
export function cleanFormPayload(object: Record<string, unknown>): Record<string, unknown> {
    const cleaned: Record<string, unknown> = {};

    for (const [key, value] of Object.entries(object)) {
        if (isPhoneFieldKey(key)) {
            cleaned[key] = isIncompletePhoneNumber(value) ? undefined : String(value).trim();
        } else if (typeof value === 'string' && value.trim() === '') {
            cleaned[key] = undefined;
        } else if (Array.isArray(value)) {
            cleaned[key] = value.map((item) =>
                typeof item === 'object' && item !== null
                    ? cleanFormPayload(item as Record<string, unknown>)
                    : item
            );
        } else if (typeof value === 'object' && value !== null) {
            cleaned[key] = cleanFormPayload(value as Record<string, unknown>);
        } else {
            cleaned[key] = value;
        }
    }

    return cleaned;
}

export function snakeifyObjectKeys(object: Record<string, unknown>): Record<string, unknown> {
    const snakeCaseObject: Record<string, unknown> = {};

    for (const [key, value] of Object.entries(object)) {
        // Recursively snakeify inner arrays
        if (Array.isArray(value)) {
            snakeCaseObject[camelToSnake(key)] = value.map((item) =>
                typeof item === 'object' && item !== null
                    ? snakeifyObjectKeys(item as Record<string, unknown>)
                    : item
            );
        } else if (typeof value === 'object' && value !== null) {
            snakeCaseObject[camelToSnake(key)] = snakeifyObjectKeys(value as Record<string, unknown>);
        } else {
            snakeCaseObject[camelToSnake(key)] = value;
        }
    }

    return snakeCaseObject;
}
